import * as React from "react";

import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";

import { Controller } from "react-hook-form";
import { RadioContainer } from "./styles";

interface IFormInput {
    name: string;
    label?: string;
    control: any;
    error: any;
    title?: string;
    opt1?: string;
    opt2?: string;
    opt3?: string;
    onChange?: (i: any) => void;
}

const RadioButton: React.FC<IFormInput> = ({ name, label, control, error, title, opt1, opt2, opt3, onChange }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value, onBlur } }) => {
                return (
                    <FormControl>
                        <FormLabel>{title}</FormLabel>
                        <RadioGroup
                            value={value || ""}
                            onChange={(item) => {
                                renderChange(item);
                                if (typeof onChange === "function") onChange(item || "");
                            }}
                            onBlur={onBlur}
                        >
                            <RadioContainer>
                                <FormControlLabel
                                    value={opt1 ? opt1 : "Não"}
                                    control={<Radio />}
                                    label={opt1 ? opt1 : "Não"}
                                />
                                <FormControlLabel
                                    value={opt2 ? opt2 : "Sim"}
                                    control={<Radio />}
                                    label={opt2 ? opt2 : "Sim"}
                                />
                                {opt3 && (
                                    <FormControlLabel
                                        value={opt3 ? opt3 : "Não"}
                                        control={<Radio />}
                                        label={opt3 ? opt3 : "Não"}
                                    />
                                )}
                            </RadioContainer>
                        </RadioGroup>
                        <FormHelperText>{!!error && error[name]?.message}</FormHelperText>
                    </FormControl>
                );
            }}
        />
    );
};

export default RadioButton;
